import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import Header from './components/Header/Header';
import Slideshow from './components/Slideshow/Slideshow';
import About from './components/About/About';
import Products from './components/Products/Products';
import Support from './components/Support/Support';
import Footer from './components/Footer/Footer';
import ContactPage from './pages/ContactPage/ContactPage';
import ProductsPage from './pages/ProductsPage/ProductsPage';
import TechnologyPage from './pages/TechnologyPage/TechnologyPage';

function App() {
  return (
    <Router>
      <div className="App">
        <Header />
        <Routes>
          <Route path="/" element={
            <>
              <Slideshow />
              <About />
              <Products />
              <Support />
            </>
          } />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/products" element={<ProductsPage />} />
          <Route path="/technology" element={<TechnologyPage />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
